import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'

export default function TelephoneNumberInput() {
  const classes = useBoldInputStyle()
  const {t} = useTranslation()

  const {
    register,
    formState: {errors},
  } = useFormContext()

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel}>{t('IPhone')} </p>
        <p className={classes.require}>*</p>
      </div>
      <input
        placeholder={t('ITel')}
        className={classes.input}
        {...register('tel')}
      />
      {errors.tel && (
        <span className={classes.errorText}>{errors.tel.message}</span>
      )}
    </div>
  )
}
